export { default } from './TableHeaderText';
